import React, { useEffect, useRef, useState } from 'react';
import { LoadingOverlay } from './LoadingOverlay/LoadingOverlay';

/**
 * Displays the loading overlay after a 300ms delay (ported from eb-ui
 * src/components/Loading.tsx — the Suspense fallback for lazy views).
 */
export const Loading: React.FunctionComponent = () => {
    const [isShown, setIsShown] = useState(false);
    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        const timer = setTimeout(() => {
            if (mounted.current) {
                setIsShown(true);
            }
        }, 300);

        return () => {
            mounted.current = false;
            clearTimeout(timer);
        };
    }, []);

    if (!isShown) {
        return null;
    }

    return (
        <div data-testid="progress-indicator">
            <LoadingOverlay isShown={true} />
        </div>
    );
};
